import { clsx } from 'clsx';
import * as React from 'react';
import { SelectDropdown } from '../../../../internal/components/SelectDropdown';
import { SingleSelectItem, ensureChildrenVisibility } from '../../../internal';
import styles from './styles.module.css';
import { generateDataTestId } from '../../../../internal/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export function SelectDesktopDropdown(props) {
  const {
    open,
    value,
    options,
    focusedIndex,
    actions,
    onKeyDown,
    insideRefs,
    dataTestId
  } = props;
  const optionsContainerRef = React.useRef(null);
  const focusedOptionRef = React.useRef(null);
  React.useEffect(() => {
    const optionsContainer = optionsContainerRef.current;
    const focusedOption = focusedOptionRef.current;
    if (open && optionsContainer && focusedOption) {
      ensureChildrenVisibility(optionsContainer, focusedOption);
      focusedOption.focus();
    }
  }, [open, focusedIndex]);
  const bindHandleOptionClickIndex = index => () => {
    actions.selectOption(index);
    actions.closeDropdown();
  };
  const bindHandleOptionMouseMoveIndex = index => () => {
    if (focusedIndex !== index) {
      actions.setFocusedIndex(index);
    }
  };
  return /*#__PURE__*/_jsx(SelectDropdown, {
    onClose: actions.closeDropdown,
    insideRefs: insideRefs,
    children: /*#__PURE__*/_jsx("div", {
      ref: optionsContainerRef,
      className: styles['list'],
      role: "listbox",
      onKeyDown: onKeyDown,
      "data-testid": generateDataTestId(dataTestId, ['dropdown']),
      children: options.map((option, index) => {
        const optionValue = option.value;
        const key = String(optionValue);
        const focused = index === focusedIndex;
        const selected = value === optionValue;
        return /*#__PURE__*/_jsx("div", {
          ref: focused ? focusedOptionRef : undefined,
          className: clsx(styles['item-wrapper'], focused && styles['focused']),
          onClick: bindHandleOptionClickIndex(index),
          onMouseMove: bindHandleOptionMouseMoveIndex(index),
          role: "option",
          "aria-selected": selected ? 'true' : undefined,
          tabIndex: 0,
          children: /*#__PURE__*/_jsx(SingleSelectItem, {
            option: option,
            selected: selected
          })
        }, key);
      })
    })
  });
}